// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProsizerAdvert_wrapper__2Mxqk","text":"ProsizerAdvert_text__326gZ","link":"ProsizerAdvert_link__39Gjc","image-box":"ProsizerAdvert_image-box__1cYan"};